<main class="main h-100 w-100">
  <div class="container h-100">
    <div class="row h-100">
      <div class="col-sm-10 col-md-8 col-lg-6 mx-auto d-table h-100">
        <div class="d-table-cell align-middle">

          <!-- Si el modo es resetPassword, mostramos el formulario de recuperar contraseña -->
          <div class="text-center mt-4" *ngIf="mode === 'resetPassword'">
            <h1 class="h2">{{ "welcome" | translate }}</h1>
            <p class="lead">
              {{ "notFilled" | translate }}
            </p>
          </div>

          <div class="card" *ngIf="mode === 'resetPassword'">
            <div class="card-body">
              <div class="m-sm-4">
                <div class="text-center">
                  <img src="/assets/img/orbis/orbis-logo.jpg" alt="Orbis Logo" class="img-fluid" width="132" height="132" />
                </div>
                <form>
                  <div class="mb-3">
                    <label class="form-label">{{ "password_new" | translate }}</label>
                    <input type="password" class="form-control form-control-lg" name="password" [(ngModel)]="userInfo.password" placeholder="{{ 'password_new' | translate }}">
                  </div>

                  <div class="mb-3">
                    <label class="form-label">{{ "confirm_password" | translate }}</label>
                    <input type="password" class="form-control form-control-lg" name="rePass" [(ngModel)]="rePass" placeholder="{{ 'confirm_password' | translate }}">
                  </div>

                  <div class="text-center mt-3">
                    <button type="button" class="btn btn-lg btn-primary" (click)="recover()">
                      {{ "recover" | translate }}
                    </button>
                  </div>

                  <div class="text-center mt-3" *ngIf="errorPasswords">
                    <div class="alert alert-danger" role="alert">
                      {{ "passwordsDoNotMatch" | translate }}
                    </div>
                  </div>

                  <div class="text-center mt-3" *ngIf="error">
                    <div class="alert alert-danger" role="alert">
                      {{ "linkNotValid" | translate }}
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>

          <!-- Si el modo es verifyEmail -->
          <div class="card" *ngIf="mode === 'verifyEmail'">
            <div class="card-body">
              <div class="m-sm-4">
                <div class="text-center">
                  <img src="/assets/img/orbis/orbis-logo.jpg" alt="Orbis Logo" class="img-fluid" width="132" height="132" />
                </div>

                <!-- Mostrar formulario si el código es válido -->
                <form *ngIf="showForm && isCodeValid">
                  <h4 class="text-center mb-4">{{ "completeAccountVerification" | translate }}</h4>

                  <div class="mb-3">
                    <label class="form-label">{{ "name" | translate }}</label>
                    <input type="text" class="form-control form-control-lg" [(ngModel)]="verifyInfo.name" name="name" required>
                  </div>

                  <div class="mb-3">
                    <label class="form-label">{{ "lastName" | translate }}</label>
                    <input type="text" class="form-control form-control-lg" [(ngModel)]="verifyInfo.lastName" name="lastName" required>
                  </div>

                  <div class="text-center mt-3">
                    <button type="button" class="btn btn-lg btn-primary" (click)="onVerifyAccount()">
                      {{ "verifyAccount" | translate }}
                    </button>
                  </div>
                </form>

                <!-- Mostrar error si el código no es válido -->
                <div *ngIf="!isCodeValid && !isLoading" class="text-center">
                  <div class="alert alert-danger" role="alert">
                    {{ errorMessage }}
                  </div>
                  <button type="button" class="btn btn-lg btn-secondary" (click)="goToLogin()">
                    {{ "goToLogin" | translate }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</main>
